import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '@shared/icon/icon.component';
import { OnUiButtonModule } from 'onclass-ui';
import { ComplaintFormComponent } from './complaint-form.component';

@NgModule({
  declarations: [ComplaintFormComponent],
  imports: [CommonModule, TranslateModule, FormsModule, OnUiButtonModule, IconComponent],
  exports: [ComplaintFormComponent],
})
export class ComplaintFormModule {}
